// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhs_vu bhs_ql bhs_va bhs_gy bhs_kg bhs_sv","ProfileAdminTools__item":"iz_b"};